/**
 * sc-pdp-configurator.js — Studio Couleur V1 Pilote
 * Moteur configurateur complet : Gamme → Finition → Forme (switch AJAX) → Taille → Coloris → Option (poignée, si Bois naturel + Bouton)
 * Toutes les étapes restent toujours dépliées ; chaque sélection (Gamme, Finition, Coloris,
 * Option si applicable) se ré-applique en cascade sur la 1ère valeur disponible de l'étape
 * suivante par défaut — y compris lors d'un changement en amont ("réinitialisation").
 * Filtrage client-side depuis le JSON island #sc-configurator-data (injecté en Liquid).
 */

(function () {
  'use strict';

  const DEBUG = new URLSearchParams(window.location.search).has('sc_debug');
  function log(...a) { if (DEBUG) console.log('[SC]', ...a); }

  const SC_CONFIG = {
    version: '3.3.1',
    gammeColors: {
      'couleur':       '#E07A5F',
      'decor-bois':    '#C9A882',
      'bois-naturel':  '#8B6347',
      'aspect-pierre': '#888480',
    },
    requiredFields: [
      { key: 'gamme',    label: 'Gamme',    validate: s => !!s.gammeCode,
        message: function() { return 'Merci de sélectionner une collection'; } },
      { key: 'finition', label: 'Finition', validate: s => !!s.finitionCode,
        message: function() { return 'Merci de sélectionner une finition'; } },
      { key: 'coloris',  label: 'Coloris',  validate: s => !!s.colorisCode,
        message: function(s) {
          var terms = { 'couleur': 'une couleur', 'decor-bois': 'un aspect bois', 'bois-naturel': 'un bois naturel', 'decor-pierre': 'un aspect pierre' };
          return 'Merci de sélectionner ' + (terms[s.gammeCode] || 'une couleur');
        }
      },
      { key: 'option',   label: 'Emplacement', validate: s => !s.optionRequired || !!s.optionCode,
        message: function() { return 'Merci de sélectionner un emplacement de poignée'; } },
      { key: 'tranche',  label: 'Décor tranche', validate: s => {
          var needsTranche = s.gammeCode === 'couleur' && s.finitionCode === 'tranche-decor-bois-couleur';
          return !needsTranche || !!s.trancheDecorCode;
        },
        message: function() { return 'Merci de sélectionner un décor des tranches'; }
      },
    ],
    storagePrefix: 'sc_config_',
  };

  // Debug overlay
  const SCDebug = {
    panel: null,
    init(pid) {
      if (!DEBUG) return;
      if (this.panel) { this.panel.remove(); this.panel = null; }
      const p = document.createElement('div');
      p.id = 'sc-debug-panel';
      p.style.cssText = 'position:fixed;bottom:16px;right:16px;z-index:9999;background:rgba(0,0,0,0.88);color:#0f0;font:11px/1.5 monospace;padding:12px 16px;border-radius:8px;max-width:340px;border:1px solid #0f0;pointer-events:none';
      p.innerHTML = '<b>[SC v' + SC_CONFIG.version + ']</b><br><span id="sc-dbg-body">init...</span>';
      document.body.appendChild(p);
      this.panel = p;
    },
    update(state, result) {
      const b = this.panel && this.panel.querySelector('#sc-dbg-body');
      if (!b) return;
      b.innerHTML = [
        'Gamme    : ' + (state.gammeCode || '—'),
        'Finition : ' + (state.finitionCode || '—'),
        'Forme    : ' + (state.formeCode || '—'),
        'Variant  : ' + (state.variantId || '—'),
        'Coloris  : ' + (state.colorisCode || '—'),
        'Tranche  : ' + (state.trancheDecorCode || '—'),
        'Option   : ' + (state.optionRequired ? (state.optionCode || '⚠️ requis') : 'n/a'),
        'ATC      : ' + (result.valid ? '✅ prêt' : '❌ ' + result.reasons.join(', ')),
      ].join('<br>');
    },
  };

  function createState(productId) {
    const KEY = SC_CONFIG.storagePrefix + productId;
    const s = {
      variantId: null, gammeCode: null, gammeNameVal: null,
      finitionCode: null, finitionName: null,
      formeCode: null, formeName: null,
      colorisCode: null, colorisName: null, colorisHex: null,
      optionCode: null, optionName: null, optionAtelierCode: null, optionRequired: false,
      trancheDecorCode: null, trancheDecorName: null,
    };
    function save()    { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch(e){} }
    function restore() { try { const d = JSON.parse(sessionStorage.getItem(KEY)||'null'); if(d) Object.assign(s,d); } catch(e){} }
    function clear()   { try { sessionStorage.removeItem(KEY); } catch(e){} Object.assign(s, { variantId:null, gammeCode:null, gammeNameVal:null, finitionCode:null, finitionName:null, formeCode:null, formeName:null, colorisCode:null, colorisName:null, colorisHex:null, optionCode:null, optionName:null, optionAtelierCode:null, optionRequired:false, trancheDecorCode:null, trancheDecorName:null }); }
    return { s, save, restore, clear };
  }

  function validate(state) {
    const failed = SC_CONFIG.requiredFields.filter(f => !f.validate(state));
    const reasons = failed.map(f => f.label + ' manquant');
    const message = failed.length > 0 && failed[0].message ? failed[0].message(state) : 'Merci de compléter votre sélection.';
    return { valid: failed.length === 0, reasons, message };
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.scMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.scMoneyFormat);
    }
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function readConfiguratorData(rootEl) {
    var dataEl = rootEl.querySelector('#sc-configurator-data');
    if (!dataEl) return null;
    try { return JSON.parse(dataEl.textContent); } catch (e) { return null; }
  }

  // Instance courante — réassignée à chaque (ré)initialisation, y compris après un swap AJAX.
  // Permet aux listeners globaux (variant:changed) de ne jamais être ré-attachés en double.
  let current = null;

  function initConfigurator(rootEl, opts) {
    opts = opts || {};
    const data = readConfiguratorData(rootEl);
    if (!data) { log('données manquantes'); return; }

    window.scMoneyFormat = data.moneyFormat;

    const productId = data.productId;
    const productData = { id: productId, variants: data.variants, selectedVariantId: data.selectedVariantId };
    const catalogData = data.catalog;
    if (!catalogData) { log('catalogue manquant'); return; }

    var finitionCodeToLabel = {};
    (catalogData.finitions || []).forEach(function(f) {
      finitionCodeToLabel[f.code] = (f.name || '').toLowerCase();
    });

    SCDebug.init(productId);

    const { s: state, save, restore } = createState(productId);
    state.variantId = productData.selectedVariantId;

    var previewBaseUrl = null;

    const atcBtn         = rootEl.querySelector('#sc-atc-btn');
    const errorEl        = rootEl.querySelector('#sc-coloris-error');
    const gammeBtns      = rootEl.querySelectorAll('[data-sc-gamme]');
    const finitionBtns   = rootEl.querySelectorAll('[data-sc-finition]');
    const formeLinks     = rootEl.querySelectorAll('[data-sc-forme]');
    const swatches       = rootEl.querySelectorAll('[data-sc-coloris]');
    const optionBtns     = rootEl.querySelectorAll('[data-sc-option]');
    const trancheBtns    = rootEl.querySelectorAll('[data-sc-tranche]');
    const stepTranche    = rootEl.querySelector('#sc-step-tranche');
    const galleryThumbItems = rootEl.querySelectorAll('#sc-gallery-thumbs [data-sc-gallery-index]');
    const gallerySlideItems = rootEl.querySelectorAll('#sc-gallery-main [data-sc-gallery-index]');
    const zoomBtn           = rootEl.querySelector('.product__zoom-button');
    const finitionSelect    = rootEl.querySelector('#sc-finition-select');
    const descriptionEl  = rootEl.querySelector('#sc-description-dynamic');
    const stepOption     = rootEl.querySelector('#sc-step-option');
    var defaultDescriptionHtml = descriptionEl ? descriptionEl.innerHTML : '';

    if (!atcBtn) { log('bouton ATC introuvable'); return; }

    function showStep(el) { if (el) el.classList.remove('sc-step--hidden'); }
    function hideStep(el) { if (el) el.classList.add('sc-step--hidden'); }

    function refreshUI() {
      const result = validate(state);
      atcBtn.classList.toggle('sc-atc-btn--locked', !result.valid);
      SCDebug.update(state, result);
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || 'Merci de compléter votre sélection.';
      errorEl.style.display = 'block';
    }
    function hideError() {
      if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
    }

    function setPreviewImage(url) {
      var img     = rootEl.querySelector('#sc-preview-img');
      var ph      = rootEl.querySelector('#sc-preview-placeholder');
      var preview = rootEl.querySelector('#sc-color-preview');
      var wash    = rootEl.querySelector('#sc-preview-color-wash');
      if (url) {
        if (img) {
          img.style.opacity = '0';
          img.src = url;
          img.alt = '';
          requestAnimationFrame(function() {
            requestAnimationFrame(function() { img.style.opacity = '1'; });
          });
        }
        if (ph) ph.style.opacity = '0';
        if (preview) preview.style.backgroundColor = '#f2ede8';
        if (wash) wash.style.opacity = '0';
      } else {
        if (img) { img.style.opacity = '0'; img.src = ''; }
        if (ph) ph.style.opacity = '1';
        if (wash) wash.style.opacity = '0';
      }
    }

    function updatePreview(hex, name, imageUrl) {
      var preview     = rootEl.querySelector('#sc-color-preview');
      var img         = rootEl.querySelector('#sc-preview-img');
      var placeholder = rootEl.querySelector('#sc-preview-placeholder');
      var badge       = rootEl.querySelector('#sc-preview-badge');
      var badgeDot    = rootEl.querySelector('#sc-preview-badge-dot');
      var badgeName   = rootEl.querySelector('#sc-preview-badge-name');
      var wash        = rootEl.querySelector('#sc-preview-color-wash');
      if (!preview) return;

      if (imageUrl) {
        if (img) {
          img.style.opacity = '0';
          img.src = imageUrl;
          img.alt = name;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() { img.style.opacity = '1'; });
          });
        }
        if (placeholder) placeholder.style.opacity = '0';
        if (wash) wash.style.opacity = '0';
        preview.style.backgroundColor = '#f2ede8';
      } else if (previewBaseUrl) {
        if (wash) {
          wash.style.backgroundColor = hex;
          wash.style.opacity = '0.2';
        }
        preview.style.backgroundColor = '#f2ede8';
        if (img && img.src !== previewBaseUrl) { img.src = previewBaseUrl; }
        if (img) img.style.opacity = '1';
        if (placeholder) placeholder.style.opacity = '0';
      } else {
        if (img) { img.style.opacity = '0'; img.src = ''; }
        if (placeholder) placeholder.style.opacity = '1';
        if (wash) wash.style.opacity = '0';
        preview.style.backgroundColor = hex;
      }

      if (badge) {
        badge.style.display = 'flex';
        if (badgeDot) badgeDot.style.backgroundColor = hex;
        if (badgeName) badgeName.textContent = name;
      }
    }

    function setGalleryActive(index) {
      galleryThumbItems.forEach(function(t) { t.classList.toggle('sc-gallery__thumb--active', t.dataset.scGalleryIndex === index); });
      var activeSlide = null;
      gallerySlideItems.forEach(function(s) {
        var isActive = s.dataset.scGalleryIndex === index;
        s.classList.toggle('sc-gallery__slide--active', isActive);
        if (s.classList.contains('product__media-item')) s.classList.toggle('is-selected', isActive);
        if (isActive) activeSlide = s;
      });
      if (zoomBtn) {
        var isProductImg  = activeSlide && !activeSlide.dataset.scGalleryColoris && activeSlide.getAttribute('data-media-type') === 'image';
        var isSituationImg = activeSlide && !!activeSlide.dataset.scGalleryColoris;
        zoomBtn.hidden = !isProductImg && !isSituationImg;
      }
    }

    // Lightbox custom pour les images situation coloris (hors product.media)
    function openSituationZoom(src) {
      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:10000;display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      var img = document.createElement('img');
      img.src = src;
      img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;display:block;';
      overlay.appendChild(img);
      function close() { if (document.body.contains(overlay)) { document.body.removeChild(overlay); document.removeEventListener('keydown', onKey); } }
      function onKey(e) { if (e.key === 'Escape') close(); }
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(overlay);
    }

    if (zoomBtn) {
      zoomBtn.addEventListener('click', function(e) {
        var activeSlide = rootEl.querySelector('#sc-gallery-main .sc-gallery__slide--active');
        if (activeSlide && activeSlide.dataset.scGalleryColoris) {
          e.stopImmediatePropagation();
          var img = activeSlide.querySelector('img');
          if (img) openSituationZoom(img.src);
        }
      }, true);
    }

    var emptySlide = rootEl.querySelector('#sc-gallery-main .sc-gallery__empty');

    // Visuels génériques produit (product.media) — état par défaut, avant ou hors sélection Gamme+Finition.
    function showGenericGallery() {
      if (emptySlide) emptySlide.classList.add('sc-gallery__slide--active');
      galleryThumbItems.forEach(function(t) { t.style.display = (t.dataset.scGalleryColoris || t.dataset.scGalleryFinition) ? 'none' : ''; });
      gallerySlideItems.forEach(function(s) { s.style.display = (s.dataset.scGalleryColoris || s.dataset.scGalleryFinition) ? 'none' : ''; });
      var firstThumb = rootEl.querySelector('#sc-gallery-thumbs [data-sc-gallery-index]:not([data-sc-gallery-coloris]):not([data-sc-gallery-finition])');
      if (firstThumb) setGalleryActive(firstThumb.dataset.scGalleryIndex);
    }

    // Visuels des coloris disponibles pour la Gamme+Finition choisie. Retombe sur la galerie
    // générique (showGenericGallery) si aucun coloris de cette combinaison n'a d'image.
    function showColorisGallery(gammeCode, finitionCode) {
      var firstMatchIndex = null;
      galleryThumbItems.forEach(function(t) {
        if (!t.dataset.scGalleryColoris) { t.style.display = 'none'; return; }
        var match = t.dataset.scColorisGamme === gammeCode && t.dataset.scColorisFinition === finitionCode;
        t.style.display = match ? '' : 'none';
        if (match && firstMatchIndex === null) firstMatchIndex = t.dataset.scGalleryIndex;
      });
      gallerySlideItems.forEach(function(s) {
        if (!s.dataset.scGalleryColoris) { s.style.display = 'none'; return; }
        var match = s.dataset.scColorisGamme === gammeCode && s.dataset.scColorisFinition === finitionCode;
        s.style.display = match ? '' : 'none';
      });
      if (firstMatchIndex !== null) {
        if (emptySlide) emptySlide.classList.remove('sc-gallery__slide--active');
        setGalleryActive(firstMatchIndex);
        return true;
      }
      return false;
    }

    // Bascule la galerie sur l'image du coloris précisément cliqué (si elle existe),
    // au lieu de rester sur le premier match de la combinaison Gamme+Finition.
    function showColorisGalleryForCode(colorisCode) {
      var thumb = rootEl.querySelector('#sc-gallery-thumbs [data-sc-gallery-coloris="' + colorisCode + '"]');
      if (!thumb) return false;
      if (emptySlide) emptySlide.classList.remove('sc-gallery__slide--active');
      galleryThumbItems.forEach(function(t) {
        t.style.display = (!t.dataset.scGalleryColoris || t.dataset.scGalleryColoris !== colorisCode) ? 'none' : '';
      });
      gallerySlideItems.forEach(function(s) {
        s.style.display = (!s.dataset.scGalleryColoris || s.dataset.scGalleryColoris !== colorisCode) ? 'none' : '';
      });
      setGalleryActive(thumb.dataset.scGalleryIndex);
      return true;
    }

    // Visuels par défaut de la Finition choisie, affichés avant tout choix de Coloris.
    // Retombe sur la galerie générique (showGenericGallery) si la finition n'a pas d'image_situation.
    function showFinitionGallery(finitionCode) {
      var thumb = rootEl.querySelector('#sc-gallery-thumbs [data-sc-gallery-finition="' + finitionCode + '"]');
      if (!thumb) return false;
      if (emptySlide) emptySlide.classList.remove('sc-gallery__slide--active');
      galleryThumbItems.forEach(function(t) {
        t.style.display = (!t.dataset.scGalleryFinition || t.dataset.scGalleryFinition !== finitionCode) ? 'none' : '';
      });
      gallerySlideItems.forEach(function(s) {
        s.style.display = (!s.dataset.scGalleryFinition || s.dataset.scGalleryFinition !== finitionCode) ? 'none' : '';
      });
      setGalleryActive(thumb.dataset.scGalleryIndex);
      return true;
    }

    function updateVariantForFinition(finitionName, tailleValOverride) {
      if (!productData.variants) return;
      var tailleVal = tailleValOverride;
      if (!tailleVal) {
        const activeVar = productData.variants.find(function(v) { return v.id == state.variantId; });
        if (!activeVar) return;
        tailleVal = activeVar.option1;
      }
      var finLower = finitionName ? finitionName.toLowerCase() : '';
      var target = productData.variants.find(function(v) {
        return v.option1 === tailleVal && (v.option2 || '').toLowerCase() === finLower;
      });
      if (target) {
        state.variantId = target.id;
        var form = atcBtn && atcBtn.closest('form');
        var idInput = form && form.querySelector('.product-variant-id');
        if (idInput) { idInput.disabled = false; idInput.value = String(target.id); }
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: target }, bubbles: true }));
        log('variant →', target.title);
      }
    }

    function setStepValue(id, text, dotHex) {
      var el = rootEl.querySelector('#' + id);
      if (el) el.textContent = text || '';
      if (id === 'sc-step-coloris-value') {
        var colorisStep = rootEl.querySelector('#sc-step-coloris');
        if (colorisStep) colorisStep.classList.toggle('sc-step--has-coloris', !!text);
        var dot = rootEl.querySelector('#sc-step-coloris-dot');
        if (dot && dotHex) dot.style.backgroundColor = dotHex;
      }
    }

    // La forme est désormais fixe pour ce produit (1 produit = 1 forme) : on l'affiche,
    // on ne la sélectionne plus localement. Changer de forme = swapToProduct().
    function markCurrentForme() {
      var selfCode = catalogData.selfFormeCode;
      var formeMeta = (catalogData.formes || []).find(function(f) { return f.code === selfCode; });
      state.formeCode = selfCode || null;
      state.formeName = formeMeta ? formeMeta.name : null;
      setStepValue('sc-step-forme-value', state.formeName);
      formeLinks.forEach(function(a) {
        var active = a.dataset.scForme === selfCode;
        a.classList.toggle('sc-forme-btn--active', active);
        a.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    function resetOption() {
      state.optionCode = null; state.optionName = null; state.optionAtelierCode = null; state.optionRequired = false;
      setStepValue('sc-step-option-value', '');
      optionBtns.forEach(function(b) { b.classList.remove('sc-option-btn--active'); b.setAttribute('aria-checked', 'false'); });
      var pOpt = rootEl.querySelector('#sc-prop-option');
      var pOptCode = rootEl.querySelector('#sc-prop-option-code');
      var pSku = rootEl.querySelector('#sc-prop-sku-atelier');
      if (pOpt) pOpt.value = '';
      if (pOptCode) pOptCode.value = '';
      if (pSku) pSku.value = '';
      hideStep(stepOption);
    }

    function updateSkuAtelier() {
      var pSku = rootEl.querySelector('#sc-prop-sku-atelier');
      if (!pSku) return;
      var variantId = state.variantId || productData.selectedVariantId;
      var v = productData.variants && productData.variants.find(function(v) { return v.id == variantId; });
      var sku = v ? (v.sku || '') : '';
      pSku.value = (sku && state.optionAtelierCode) ? sku + '_' + state.optionAtelierCode : sku;
    }

    function getAvailableOptions() {
      if (!state.finitionCode) return [];
      // Résoudre la taille courante depuis le variant Shopify actif
      var variantId = state.variantId || productData.selectedVariantId;
      var shopVar = productData.variants && productData.variants.find(function(v) {
        return v.id == variantId;
      });
      var tailleLabel = shopVar && shopVar.option1;
      // Chercher dans le catalogue par taille + finition (robuste vs. comparaison d'ID).
      // Comparer au LIBELLÉ (finitionCodeToLabel), pas au code slugifié : un code multi-mots
      // comme "prise-de-main" (tiret) ne matche jamais le libellé Shopify "Prise de main" (espace).
      var finLabel = finitionCodeToLabel[state.finitionCode] || state.finitionCode;
      var catVariant = null;
      if (tailleLabel) {
        catVariant = catalogData.variants && catalogData.variants.find(function(cv) {
          return cv.options &&
            cv.options.Taille === tailleLabel &&
            (cv.options.Finition || '').toLowerCase() === finLabel.toLowerCase();
        });
      }
      var allowed = catVariant && catVariant.positionsPoignee && catVariant.positionsPoignee.length > 0
        ? catVariant.positionsPoignee : null;
      return Array.prototype.filter.call(optionBtns, function(b) {
        if (b.dataset.scOptionFinition !== state.finitionCode) return false;
        if (!allowed) return true;
        return allowed.indexOf(b.dataset.scOption) >= 0;
      });
    }

    function refreshOptionStep() {
      if (!state.finitionCode) return;
      var availableOpts = getAvailableOptions();
      state.optionRequired = availableOpts.length > 0;
      optionBtns.forEach(function(b) {
        b.style.display = availableOpts.indexOf(b) >= 0 ? '' : 'none';
      });
      if (availableOpts.length > 0) {
        var stillValid = state.optionCode && availableOpts.some(function(b) {
          return b.dataset.scOption === state.optionCode;
        });
        if (!stillValid) {
          resetOption();
          selectOption(availableOpts[0].dataset.scOption, availableOpts[0].dataset.scOptionName);
        }
        showStep(stepOption);
      }
    }

    function selectOption(code, name) {
      var btn = rootEl.querySelector('[data-sc-option="' + code + '"]');
      var atelierCode = btn ? (btn.dataset.scOptionAtelierCode || '') : '';
      state.optionCode = code; state.optionName = name; state.optionAtelierCode = atelierCode;
      setStepValue('sc-step-option-value', name);
      optionBtns.forEach(function(b) {
        var active = b.dataset.scOption === code;
        b.classList.toggle('sc-option-btn--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      var pOpt = rootEl.querySelector('#sc-prop-option');
      var pOptCode = rootEl.querySelector('#sc-prop-option-code');
      if (pOpt) pOpt.value = name;
      if (pOptCode) pOptCode.value = code;
      updateSkuAtelier();
      hideError();
      refreshUI();
      save();
      log('option →', code, atelierCode || '(no atelierCode)');
    }

    function resetTranche() {
      state.trancheDecorCode = null; state.trancheDecorName = null;
      setStepValue('sc-step-tranche-value', '');
      trancheBtns.forEach(function(b) { b.classList.remove('sc-tranche-btn--active'); b.setAttribute('aria-checked', 'false'); });
      var pTr = rootEl.querySelector('#sc-prop-tranche');
      var pTrCode = rootEl.querySelector('#sc-prop-tranche-code');
      if (pTr) pTr.value = '';
      if (pTrCode) pTrCode.value = '';
      hideStep(stepTranche);
    }

    function selectTranche(code, name) {
      state.trancheDecorCode = code; state.trancheDecorName = name;
      setStepValue('sc-step-tranche-value', name);
      trancheBtns.forEach(function(b) {
        var active = b.dataset.scTranche === code;
        b.classList.toggle('sc-tranche-btn--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      var pTr = rootEl.querySelector('#sc-prop-tranche');
      var pTrCode = rootEl.querySelector('#sc-prop-tranche-code');
      if (pTr) pTr.value = name;
      if (pTrCode) pTrCode.value = code;
      hideError();
      refreshUI();
      save();
      log('tranche →', code);
    }

    function filterFinitionsByTaille() {
      if (!productData.variants || !state.gammeCode) return;
      var activeVar = productData.variants.find(function(v) { return v.id == state.variantId; });
      if (!activeVar || !activeVar.option1) return;
      var tailleVal = activeVar.option1;
      var availableLabels = [];
      productData.variants.forEach(function(v) {
        if (v.option1 === tailleVal && v.option2) {
          var lbl = v.option2.trim().toLowerCase();
          if (availableLabels.indexOf(lbl) < 0) availableLabels.push(lbl);
        }
      });
      if (availableLabels.length === 0) return;
      finitionBtns.forEach(function(b) {
        if (b.dataset.scFinitionGamme !== state.gammeCode) return;
        var finName = finitionCodeToLabel[b.dataset.scFinition] || '';
        var ok = availableLabels.some(function(lbl) { return finName.startsWith(lbl); });
        if (!ok) b.style.display = 'none';
      });
      if (state.finitionCode) {
        var activeFinBtn = rootEl.querySelector('[data-sc-finition="' + state.finitionCode + '"][data-sc-finition-gamme="' + state.gammeCode + '"]');
        if (activeFinBtn && activeFinBtn.style.display === 'none') {
          state.finitionCode = null; state.finitionName = null;
          state.colorisCode = null; state.colorisName = null; state.colorisHex = null;
          setStepValue('sc-step-finition-value', '');
          setStepValue('sc-step-coloris-value', '');
          swatches.forEach(function(s) { s.style.display = 'none'; });
          resetOption();
          resetTranche();
        }
      }
    }

    function filterTailleByFinition() {
      if (!productData.variants || !state.finitionCode) return;
      var finLabel = finitionCodeToLabel[state.finitionCode] || '';
      var availableTailles = [];
      productData.variants.forEach(function(v) {
        if (!v.option1 || !v.option2) return;
        var lbl = v.option2.trim().toLowerCase();
        if (finLabel.startsWith(lbl) || lbl.startsWith(finLabel)) {
          if (availableTailles.indexOf(v.option1) < 0) availableTailles.push(v.option1);
        }
      });
      if (availableTailles.length === 0) return;

      rootEl.querySelectorAll('.combo-box__option-item').forEach(function(item) {
        var vis = availableTailles.indexOf(item.getAttribute('value')) >= 0;
        item.style.display = vis ? '' : 'none';
      });

      var tailleSelect = rootEl.querySelector('select[aria-label="Taille"]');
      if (tailleSelect) {
        Array.prototype.forEach.call(tailleSelect.options, function(opt) {
          opt.disabled = availableTailles.indexOf(opt.value) < 0;
        });
      }

      // Si la taille actuellement sélectionnée n'existe pas pour cette finition,
      // basculer automatiquement sur la première taille disponible.
      var activeVar = productData.variants.find(function(v) { return v.id == state.variantId; });
      var currentTaille = activeVar && activeVar.option1;
      if (currentTaille && availableTailles.indexOf(currentTaille) < 0) {
        updateVariantForFinition(state.finitionName, availableTailles[0]);
      }
    }

    function selectGamme(gammeCode, gammeName, doSave) {
      if (doSave === undefined) doSave = true;
      state.gammeCode = gammeCode; state.gammeNameVal = gammeName;
      setStepValue('sc-step-gamme-value', gammeName);

      gammeBtns.forEach(function(b) {
        var active = b.dataset.scGamme === gammeCode;
        b.classList.toggle('sc-gamme-btn--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      var pG = rootEl.querySelector('#sc-prop-gamme');
      var pGc = rootEl.querySelector('#sc-prop-gamme-code');
      if (pG) pG.value = gammeName;
      if (pGc) pGc.value = gammeCode;

      var gammeBtn = rootEl.querySelector('[data-sc-gamme="' + gammeCode + '"]');
      var gammeImgUrl = (gammeBtn && gammeBtn.dataset.scGammeImage) || null;
      previewBaseUrl = gammeImgUrl;
      setPreviewImage(gammeImgUrl);
      if (!gammeImgUrl) {
        var previewEl = rootEl.querySelector('#sc-color-preview');
        if (previewEl) previewEl.style.backgroundColor = SC_CONFIG.gammeColors[gammeCode] || '#f3f0ed';
      }
      var badge = rootEl.querySelector('#sc-preview-badge');
      if (badge) badge.style.display = 'none';

      var visibleFins = [];
      finitionBtns.forEach(function(b) {
        var vis = b.dataset.scFinitionGamme === gammeCode;
        b.style.display = vis ? '' : 'none';
        if (vis) visibleFins.push(b);
      });
      filterFinitionsByTaille();
      visibleFins = visibleFins.filter(function(b) { return b.style.display !== 'none'; });

      showGenericGallery();

      var pf = rootEl.querySelector('#sc-prop-finition');
      if (pf) pf.value = '';

      if (visibleFins.length > 0) {
        selectFinition(visibleFins[0].dataset.scFinition, visibleFins[0].dataset.scFinitionName, false);
      } else {
        state.finitionCode = null; state.finitionName = null;
        state.colorisCode = null; state.colorisName = null; state.colorisHex = null;
        setStepValue('sc-step-finition-value', '');
        setStepValue('sc-step-taille-value',   '');
        setStepValue('sc-step-coloris-value',  '');
        swatches.forEach(function(s) { s.style.display = 'none'; });
        resetOption();
      }

      refreshUI();
      if (doSave) save();
      log('gamme →', gammeCode);
    }

    function selectFinition(finitionCode, finitionName, doSave) {
      if (doSave === undefined) doSave = true;
      state.finitionCode = finitionCode; state.finitionName = finitionName;
      state.colorisCode = null; state.colorisName = null; state.colorisHex = null;
      setStepValue('sc-step-finition-value', finitionName);
      setStepValue('sc-step-taille-value',   '');
      setStepValue('sc-step-coloris-value',  '');

      filterTailleByFinition();

      var finBtn = rootEl.querySelector('[data-sc-finition="' + finitionCode + '"][data-sc-finition-gamme="' + state.gammeCode + '"]');
      var finImgUrl = (finBtn && finBtn.dataset.scFinitionImage) || null;
      if (finImgUrl) {
        previewBaseUrl = finImgUrl;
        setPreviewImage(finImgUrl);
      }
      var wash = rootEl.querySelector('#sc-preview-color-wash');
      if (wash) wash.style.opacity = '0';
      var badge = rootEl.querySelector('#sc-preview-badge');
      if (badge) badge.style.display = 'none';

      finitionBtns.forEach(function(b) {
        var active = b.dataset.scFinition === finitionCode && b.dataset.scFinitionGamme === state.gammeCode;
        b.classList.toggle('sc-finition-btn--active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      var pFin = rootEl.querySelector('#sc-prop-finition');
      var pFinCode = rootEl.querySelector('#sc-prop-finition-code');
      if (pFin) pFin.value = finitionName;
      if (pFinCode) pFinCode.value = finitionCode;

      if (descriptionEl) {
        var finEntry = (catalogData.finitions || []).find(function(f) {
          return f.code === finitionCode && f.gammeCode === state.gammeCode;
        });
        descriptionEl.innerHTML = (finEntry && finEntry.description) ? finEntry.description : defaultDescriptionHtml;
      }

      if (finitionSelect) {
        for (var i = 0; i < finitionSelect.options.length; i++) {
          if (finitionSelect.options[i].value.toLowerCase() === finitionName.toLowerCase()) {
            finitionSelect.options[i].selected = true;
            finitionSelect.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }

      updateVariantForFinition(finitionName);

      var matchingSwatches = [];
      swatches.forEach(function(s) {
        var match = s.dataset.scColorisFinition === finitionCode;
        s.style.display = match ? '' : 'none';
        if (match) matchingSwatches.push(s);
      });

      if (!showFinitionGallery(finitionCode)) showGenericGallery();

      state.colorisCode = null; state.colorisName = null; state.colorisHex = null;
      setStepValue('sc-step-coloris-value', '');
      resetOption();
      resetTranche();

      var availableOpts = getAvailableOptions();
      state.optionRequired = availableOpts.length > 0;
      if (availableOpts.length > 0) {
        optionBtns.forEach(function(b) { b.style.display = availableOpts.indexOf(b) >= 0 ? '' : 'none'; });
        showStep(stepOption);
        selectOption(availableOpts[0].dataset.scOption, availableOpts[0].dataset.scOptionName);
      }

      if (state.gammeCode === 'couleur' && finitionCode === 'tranche-decor-bois-couleur') {
        showStep(stepTranche);
      }

      hideError();
      refreshUI();
      if (doSave) save();
      log('finition →', finitionCode, '| coloris:', matchingSwatches.length);
    }

    function selectColoris(swatch, doSave) {
      if (doSave === undefined) doSave = true;
      var code     = swatch.dataset.scColoris;
      var name     = swatch.dataset.scColorisName;
      var hex      = swatch.dataset.scColorisHex;
      var imageUrl = swatch.dataset.scColorisImage || '';

      state.colorisCode = code; state.colorisName = name; state.colorisHex = hex;

      var pC = rootEl.querySelector('#sc-prop-coloris');
      var pCode = rootEl.querySelector('#sc-prop-coloris-code');
      var pHex  = rootEl.querySelector('#sc-prop-coloris-hex');
      if (pC) pC.value = name;
      if (pCode) pCode.value = code;
      if (pHex) pHex.value = hex;

      setStepValue('sc-step-coloris-value', name, hex);

      swatches.forEach(function(s) {
        s.classList.toggle('sc-swatch--selected', s === swatch);
        s.setAttribute('aria-checked', s === swatch ? 'true' : 'false');
      });

      updatePreview(hex, name, imageUrl);
      if (!showColorisGalleryForCode(code)) showGenericGallery();

      hideError();
      refreshUI();
      if (doSave) save();
      log('coloris →', code, hex);
    }

    function swapToProduct(targetHandle, targetUrl) {
      if (!targetHandle || targetHandle === data.productHandle) return;

      var carry = {
        gammeCode: state.gammeCode, gammeNameVal: state.gammeNameVal,
        finitionCode: state.finitionCode, finitionName: state.finitionName,
        colorisCode: state.colorisCode, colorisName: state.colorisName, colorisHex: state.colorisHex,
        optionCode: state.optionCode, optionName: state.optionName,
      };

      // L'ancien contenu reste visible pendant le fetch — pas d'opacity à 0, pas de blank.
      // Swap instantané quand le fetch est prêt. Pas d'animation pour éviter tout flash.
      rootEl.style.pointerEvents = 'none';

      fetch('/products/' + targetHandle + '?section_id=sc-main-product-configurator')
        .then(function(res) {
          if (!res.ok) throw new Error('fetch failed: ' + res.status);
          return res.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.getElementById('sc-configurator-root');
          if (!newRoot) throw new Error('section sc-configurator-root introuvable dans la réponse');
          rootEl.replaceWith(newRoot);
          initConfigurator(newRoot, { carryOver: carry });
        })
        .catch(function(err) {
          rootEl.style.pointerEvents = '';
          log('swap échoué, navigation classique →', targetUrl, err);
          if (targetUrl) window.location.href = targetUrl;
        });
    }

    // Events
    gammeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { selectGamme(btn.dataset.scGamme, btn.dataset.scGammeName); });
    });
    finitionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { selectFinition(btn.dataset.scFinition, btn.dataset.scFinitionName); });
    });
    formeLinks.forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.preventDefault();
        swapToProduct(a.dataset.scFormeHandle, a.dataset.scFormeUrl);
      });
    });
    swatches.forEach(function(s) {
      s.addEventListener('click', function() { selectColoris(s); });
      s.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectColoris(s); } });
    });
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { selectOption(btn.dataset.scOption, btn.dataset.scOptionName); });
      btn.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(btn.dataset.scOption, btn.dataset.scOptionName); } });
    });
    trancheBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { selectTranche(btn.dataset.scTranche, btn.dataset.scTrancheName); });
      btn.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTranche(btn.dataset.scTranche, btn.dataset.scTrancheName); } });
    });

    // Click guard (capture phase — intercepte avant loader-button de Focal)
    atcBtn.addEventListener('click', function(e) {
      var result = validate(state);
      if (!result.valid) {
        e.preventDefault(); e.stopImmediatePropagation();
        showError(result.message);
        var needsTranche = state.gammeCode === 'couleur' && state.finitionCode === 'tranche-decor-bois-couleur';
        var target = !state.gammeCode ? '#sc-step-gamme'
                   : !state.finitionCode ? '#sc-step-finition'
                   : needsTranche && !state.trancheDecorCode ? '#sc-step-tranche'
                   : !state.colorisCode ? '[data-sc-swatches]'
                   : state.optionRequired && !state.optionCode ? '#sc-step-option'
                   : '[data-sc-swatches]';
        var el = rootEl.querySelector(target);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        log('ATC bloqué :', result.reasons);
        return;
      }
    }, true);

    var form = atcBtn.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        var result = validate(state);
        if (!result.valid) {
          e.preventDefault(); e.stopImmediatePropagation();
          return;
        }
        var idInput = form.querySelector('.product-variant-id');
        if (idInput && idInput.disabled) {
          idInput.disabled = false;
          idInput.value = String(state.variantId || productData.selectedVariantId);
        }
        log('submit →', { variant: idInput && idInput.value, coloris: state.colorisName });
      }, true);
    }

    // ── Lecture des params URL (?sc_gamme=...&sc_finition=...&sc_coloris=...) ──
    // Toutes les étapes restant toujours dépliées avec une valeur par défaut
    // (cf. selectGamme/selectFinition/selectColoris), ces params ne font que
    // remplacer après-coup la valeur par défaut par celle demandée dans l'URL.

    function initFromUrlParams() {
      var params = new URLSearchParams(window.location.search);
      var urlGamme    = params.get('sc_gamme');
      var urlFinition = params.get('sc_finition');
      var urlColoris  = params.get('sc_coloris');
      if (!urlGamme) return false;

      var gammeBtn2 = rootEl.querySelector('[data-sc-gamme="' + urlGamme + '"]');
      if (!gammeBtn2) return false;

      selectGamme(urlGamme, gammeBtn2.dataset.scGammeName, false);
      log('URL param → gamme:', urlGamme);

      if (!urlFinition) { save(); return true; }

      setTimeout(function() {
        var finBtn2 = rootEl.querySelector('[data-sc-finition="' + urlFinition + '"][data-sc-finition-gamme="' + urlGamme + '"]');
        if (!finBtn2) { save(); return; }
        selectFinition(urlFinition, finBtn2.dataset.scFinitionName, false);
        log('URL param → finition:', urlFinition);

        if (!urlColoris) { save(); return; }

        setTimeout(function() {
          var swatch = rootEl.querySelector('[data-sc-coloris="' + urlColoris + '"][data-sc-coloris-gamme="' + urlGamme + '"][data-sc-coloris-finition="' + urlFinition + '"]');
          if (swatch) {
            selectColoris(swatch, false);
            log('URL param → coloris:', urlColoris);
          }
          save();
        }, 50);
      }, 50);

      return true;
    }

    markCurrentForme();

    // ── Restauration de l'état ────────────────────────────────────────────
    if (opts.carryOver && opts.carryOver.gammeCode) {
      // Switch de forme : on réapplique Gamme/Finition/Coloris depuis le produit précédent.
      refreshUI();
      selectGamme(opts.carryOver.gammeCode, opts.carryOver.gammeNameVal, false);
      if (opts.carryOver.finitionCode) {
        setTimeout(function() {
          // Vérifie que la finition existe et est visible sur ce produit avant de la restaurer.
          // Si elle n'existe pas (ex. Cadre couleur sur Fileur), selectGamme a déjà
          // auto-sélectionné la première finition disponible — on ne l'écrase pas.
          var finBtn = rootEl.querySelector(
            '[data-sc-finition="' + opts.carryOver.finitionCode + '"]' +
            '[data-sc-finition-gamme="' + opts.carryOver.gammeCode + '"]'
          );
          if (finBtn && finBtn.style.display !== 'none') {
            selectFinition(opts.carryOver.finitionCode, opts.carryOver.finitionName, false);
            if (opts.carryOver.colorisCode) {
              setTimeout(function() {
                var swatch = rootEl.querySelector('[data-sc-coloris="' + opts.carryOver.colorisCode + '"]');
                if (swatch) selectColoris(swatch, false);
                if (opts.carryOver.optionCode) {
                  var optBtn = rootEl.querySelector('[data-sc-option="' + opts.carryOver.optionCode + '"]');
                  if (optBtn) selectOption(opts.carryOver.optionCode, opts.carryOver.optionName);
                }
                save();
              }, 50);
            } else {
              save();
            }
          } else {
            save();
          }
        }, 50);
      } else {
        save();
      }
    } else {
      refreshUI();
      var loadedFromUrl = initFromUrlParams();
      if (!loadedFromUrl) {
        restore();
        if (state.gammeCode) {
          var saved = {
            gammeCode: state.gammeCode, gammeNameVal: state.gammeNameVal,
            finitionCode: state.finitionCode, finitionName: state.finitionName,
            colorisCode: state.colorisCode,
            optionCode: state.optionCode, optionName: state.optionName,
            trancheDecorCode: state.trancheDecorCode, trancheDecorName: state.trancheDecorName,
          };
          selectGamme(saved.gammeCode, saved.gammeNameVal || saved.gammeCode, false);
          if (saved.finitionCode) {
            setTimeout(function() {
              selectFinition(saved.finitionCode, saved.finitionName || saved.finitionCode, false);
              if (saved.trancheDecorCode) {
                var trancheBtn = rootEl.querySelector('[data-sc-tranche="' + saved.trancheDecorCode + '"]');
                if (trancheBtn) selectTranche(saved.trancheDecorCode, saved.trancheDecorName);
              }
              if (saved.colorisCode) {
                setTimeout(function() {
                  var swatch = rootEl.querySelector('[data-sc-coloris="' + saved.colorisCode + '"]');
                  if (swatch) selectColoris(swatch, false);
                  if (saved.optionCode) {
                    var optBtn = rootEl.querySelector('[data-sc-option="' + saved.optionCode + '"]');
                    if (optBtn) selectOption(saved.optionCode, saved.optionName);
                  }
                  save();
                }, 50);
              } else {
                save();
              }
            }, 50);
          } else {
            save();
          }
        } else if (gammeBtns.length > 0) {
          // Pas de session ni de param URL : on atterrit par défaut sur la 1ère gamme.
          selectGamme(gammeBtns[0].dataset.scGamme, gammeBtns[0].dataset.scGammeName, true);
        }
      }
    }

    // ── Taille : mise à jour du header au clic sur le combo-box ─────────────
    rootEl.querySelectorAll('.combo-box__option-item').forEach(function(item) {
      item.addEventListener('click', function() {
        setStepValue('sc-step-taille-value', item.textContent.trim());
      });
    });

    // ── Galerie : navigation par thumbnails ──────────────────────────────────
    var galleryThumbs = rootEl.querySelector('#sc-gallery-thumbs');
    var galleryMain   = rootEl.querySelector('#sc-gallery-main');
    if (galleryThumbs && galleryMain) {
      galleryThumbs.querySelectorAll('[data-sc-gallery-index]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var idx = thumb.dataset.scGalleryIndex;
          galleryThumbs.querySelectorAll('[data-sc-gallery-index]').forEach(function(t) {
            t.classList.toggle('sc-gallery__thumb--active', t.dataset.scGalleryIndex === idx);
          });
          galleryMain.querySelectorAll('[data-sc-gallery-index]').forEach(function(slide) {
            slide.classList.toggle('sc-gallery__slide--active', slide.dataset.scGalleryIndex === idx);
          });
        });
      });
    }

    current = { rootEl: rootEl, state: state, save: save, setStepValue: setStepValue, filterFinitionsByTaille: filterFinitionsByTaille, updateSkuAtelier: updateSkuAtelier, refreshOptionStep: refreshOptionStep, updateVariantForFinition: updateVariantForFinition };

    log('v' + SC_CONFIG.version + ' prêt', { productId: productId });
  }

  // Listener global unique (jamais ré-attaché) — délègue à l'instance courante,
  // qui change après chaque (ré)initialisation y compris un swap AJAX de forme.
  document.addEventListener('variant:changed', function(e) {
    if (!current) return;
    var v = e.detail && e.detail.variant;
    if (!v) return;

    var finitionMatches = !current.state.finitionName || !v.option2 ||
      v.option2.toLowerCase() === current.state.finitionName.toLowerCase();

    if (!finitionMatches) {
      // Focal a résolu la nouvelle taille sur une autre finition que celle choisie
      // (ex: pas de correspondance exacte) — on force le retour sur la finition
      // de l'utilisateur pour cette nouvelle taille plutôt que de figer l'état.
      if (v.option1 && current.state.finitionName && current.updateVariantForFinition) {
        current.updateVariantForFinition(current.state.finitionName, v.option1);
      }
      return;
    }

    var tailleChanged = v.option1 && v.option1 !== current.lastTaille;
    current.state.variantId = v.id;
    current.lastTaille = v.option1;
    current.setStepValue('sc-step-taille-value', v.option1 || '');
    if (tailleChanged && current.filterFinitionsByTaille) current.filterFinitionsByTaille();
    if (tailleChanged && current.refreshOptionStep) current.refreshOptionStep();
    if (current.updateSkuAtelier) current.updateSkuAtelier();
    current.save();

    if (v.price) {
      var newPrice = formatMoney(v.price);
      current.rootEl.querySelectorAll('[data-sc-price-top], [data-sc-price-bottom]').forEach(function(el) {
        el.textContent = newPrice;
      });
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      current.rootEl.querySelectorAll('[data-sc-compare-price-top], [data-sc-compare-price-bottom]').forEach(function(el) {
        el.style.display = hasCompare ? '' : 'none';
        if (hasCompare) el.textContent = formatMoney(v.compare_at_price);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    var root = document.getElementById('sc-configurator-root');
    if (root) initConfigurator(root);
  });

})();
